export enum AppParts {
    WORK_RECORDS_ADD_MULTIPLE_WORK_HOURS = "WORK_RECORDS_ADD_MULTIPLE_WORK_HOURS",
    WORK_RECORDS_SEND_TO_FINALIZE = "WORK_RECORDS_SEND_TO_FINALIZE",
    USER_TOP_BAR_SECTION = "USER_TOP_BAR_SECTION",
    WORK_RECORDS_CLOSED_PERIOD = "WORK_RECORDS_CLOSED_PERIOD",
    WORK_RECORDS_UPLOAD_CHECKED_FOR_UPLOAD = "WORK_RECORDS_UPLOAD_CHECKED_FOR_UPLOAD",
    WORK_RECORDS_UPLOAD_ALREADY_UPLOADED = "WORK_RECORDS_UPLOAD_ALREADY_UPLOADED",
    WORK_RECORDS_FINALIZE_FINALIZED = "WORK_RECORDS_FINALIZE_FINALIZED",
    WORK_RECORDS_FINALIZE_NOT_FINALIZED = "WORK_RECORDS_FINALIZE_NOT_FINALIZED",
    WORK_RECORDS_OVERVIEW_LOCKED = "WORK_RECORDS_OVERVIEW_LOCKED",
    WORK_RECORDS_OVERVIEW_WORKERS_EDIT = "WORK_RECORDS_OVERVIEW_WORKERS_EDIT",
    WORK_RECORDS_OVERVIEW_WORKERS = "WORK_RECORDS_OVERVIEW_WORKERS",
    WORK_RECORDS_OVERVIEW_COST = "WORK_RECORDS_OVERVIEW_COST",
    WORK_RECORDS_OVERVIEW_BEARER = "WORK_RECORDS_OVERVIEW_BEARER",
    YOU_CAN_ALWAYS_RESTART_THIS_HELP = "YOU_CAN_ALWAYS_RESTART_THIS_HELP",
    WORK_RECORDS_ADD_ROW_BUTTON = "WORK_RECORDS_ADD_ROW_BUTTON",
    WORK_RECORDS_TABLE = "WORK_RECORDS_TABLE",
    WORK_RECORDS_DATE_PICKER = "WORK_RECORDS_DATE_PICKER",
    ADMIN_WORK_RECORDS_USER_PICKER = "ADMIN_WORK_RECORDS_USER_PICKER",
    WORK_RECORDS_UPLOAD_USERS = "WORK_RECORDS_UPLOAD_USERS",
    WORK_RECORDS_UPLOAD_DATE = "WORK_RECORDS_UPLOAD_DATE",
    WORK_RECORDS_FINALIZE_USERS = "WORK_RECORDS_FINALIZE_USERS",
    WORK_RECORDS_FINALIZE_DATE = "WORK_RECORDS_FINALIZE_DATE",
    WORK_RECORDS_OVERVIEW_RESULTS = "WORK_RECORDS_OVERVIEW_RESULTS",
    WORK_RECORDS_OVERVIEW_FILTERS = "work_records_overview_filters",
    TENANT_DATA_SYNC = "tenant_data_sync",
    COST_TYPES = "cost_types",
    EDITING_WORK_RECORD_CALENDAR = "EDITING_WORK_RECORD_CALENDAR",
    WORK_RECORDS_FIRST_DAY = "WORK_RECORDS_FIRST_DAY",
    TRAVEL_WARRANT_COST_TYPES = "TRAVEL_WARRANT_COST_TYPES",
    TRAVEL_WARRANTS_STATUS = "TRAVEL_WARRANTS_STATUS",
    TRAVEL_WARRANTS_WORKER = "TRAVEL_WARRANTS_WORKER",
    TRAVEL_WARRANTS_SEARCH = "TRAVEL_WARRANTS_SEARCH",
    TRAVEL_WARRANTS_TABLE = "TRAVEL_WARRANTS_TABLE",
    ADD_TRAVEL_WARRANT_BUTTON = "ADD_TRAVEL_WARRANT_BUTTON",
    NEW_TRAVEL_WARRANT_TAB = "NEW_TRAVEL_WARRANT_TAB",
    PICK_WORKER_ON_TRAVEL_WARRANT = "PICK_WORKER_ON_TRAVEL_WARRANT",
    NEW_TRAVEL_WARRANT_PICK_PROJECT = "NEW_TRAVEL_WARRANT_PICK_PROJECT",
    NEW_TRAVEL_WARRANT_GENERAL_TRANSPORT = "NEW_TRAVEL_WARRANT_GENERAL_TRANSPORT",
    NEW_TRAVEL_WARRANT_PERSONAL_VEHICLE = "NEW_TRAVEL_WARRANT_PERSONAL_VEHICLE",
    NEW_TRAVEL_WARRANT_OFFICIAL_VEHICLE = "NEW_TRAVEL_WARRANT_OFFICIAL_VEHICLE",
    NEW_TRAVEL_WARRANT_PER_DIEMS = "NEW_TRAVEL_WARRANT_PER_DIEMS",
    NEW_TRAVEL_WARRANT_PERSONAL_VEHICLE_CALLOUT = "NEW_TRAVEL_WARRANT_PERSONAL_VEHICLE_CALLOUT",
    NEW_TRAVEL_WARRANT_ITEMS_TAB = "NEW_TRAVEL_WARRANT_ITEMS_TAB",
    NEW_TRAVEL_WARRANT_ITEMS_TABLE = "NEW_TRAVEL_WARRANT_ITEMS_TABLE",
    MARSERVIS_WORKORDERS_ENDING_SOON = "MARSERVIS_WORKORDERS_ENDING_SOON",
}
